import styled from "styled-components";

import { c, colorPrimitives, colorTokens, v } from "constants/css";

export const DoubleDatepickerContent = styled.div`
  display: grid;
  grid-template-columns: 224px 1fr;
`;

export const DropDownMenu = styled.div<{ anchor?: "left" | "right" }>`
  position: absolute;
  top: calc(100% + ${v.gUnit});

  ${({ anchor }) => anchor === "left" && "left: 0;"}
  ${({ anchor }) => anchor === "right" && "right: 0;"}

  border: 1px solid rgba(6, 6, 48, 0.04);
  box-shadow: ${v.boxShadow};
  background-color: ${c.colorWhite};
  border-radius: ${v.mainBorderRadius};
  z-index: 11;
`;

export const InfoTooltipWrapper = styled.div`
  position: absolute;
  top: ${v.gUnit};
  right: ${v.gUnit};
  z-index: ${v.zIndexHoverTooltip};
`;

export const DropDownActions = styled.div`
  grid-column: 1 / 3;
  padding: ${v.gUnitDouble};
  display: flex;
  justify-content: space-between;
  border-top: ${c.colorGrey2} 1px solid;
`;

export const ListItemGroup = styled.ul`
  list-style: none;
  padding: ${v.gUnitTriple} 0;
  width: 100%;
  margin: 0;
  border-right: ${c.colorGrey2} 1px solid;
`;

export const ListItemButton = styled.button<{ selected: boolean }>`
  display: flex;
  align-items: center;
  border: none;
  background: ${(p) => (p.selected ? colorPrimitives.teal100 : "none")};
  color: ${colorTokens.textMain};
  font-weight: ${(p) => (p.selected ? 600 : 400)};
  width: 100%;
  cursor: pointer;
  padding: 0 ${v.gUnitDouble};
  text-align: left;

  &:hover {
    background: ${colorTokens.actionHover};
  }

  ${(p) =>
    p.disabled &&
    `
    color: ${colorTokens.actionDisabled};
    pointer-events: none;
  `}
`;

export const ListItemLabel = styled.span`
  line-height: 38px;
  font-size: ${v.smallFontSize};
  flex-grow: 1;
  font-family: inherit;
`;

export const ListItemIcon = styled.span`
  margin-top: ${v.gUnitHalf};
`;

export const CalendarGroup = styled.div`
  padding: ${v.gUnitTriple};
`;

export const CalendarInputs = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${v.gUnitTriple};
`;

export const Calendar = styled.div`
  padding: ${v.gUnitDouble} 0;
`;

export const DateInput = styled.div`
  width: 224px;
`;

export const Timezone = styled.span`
  font-size: ${v.xSmallFontSize};
  line-height: ${v.smallLineHeight};
`;

export const Disclaimer = styled.section`
  margin-top: ${v.gUnit};
  display: flex;
  align-items: center;
  font-size: ${v.xSmallFontSize};
  line-height: ${v.smallLineHeight};
`;
